import { Checkbox } from '@/components/ui/checkbox'
import { ResponseThread } from '@/schema'
import { formatFullName } from '@/utils/common'

export const TransferItem = ({
  comment,
  isSelected,
  onToggle,
}: {
  comment: ResponseThread
  isSelected: boolean
  onToggle: (commentId: string) => void
}) => {
  const author = formatFullName(
    comment.created_by_user?.first_name ?? '',
    comment.created_by_user?.last_name ?? ''
  )
  const isFileLevelComment = !comment.annotation

  const handleChange = () => {
    onToggle(comment.id)
  }

  return (
    <div className="flex flex-col">
      <Checkbox
        checked={isSelected}
        onChange={handleChange}
        label={comment.content}
        checkBoxClassName="w-4 h-4"
        labelClassName="text-sm text-primary-900 font-semibold line-clamp-1"
      />
      <div className="text-sm text-tertiary-600 ml-7">
        {`${isFileLevelComment ? 'File-level' : 'Section-level'} comment • by ${author}`}
      </div>
    </div>
  )
}
